import styled from 'styled-components';

export const DetailActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0 8px 0;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/DetailActions.js